export var argTypes = {
    negative: {
        control: {
            type: 'boolean',
        },
    },
    neutral: {
        control: {
            type: 'boolean',
        },
    },
};
//# sourceMappingURL=SvgLogo.types.js.map